import { render, staticRenderFns } from "./DataSourceAttributeSettingsDialog.vue?vue&type=template&id=922d16c2&"
import script from "./DataSourceAttributeSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./DataSourceAttributeSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports